module.exports = __webpack_public_path__ + "img/thumb_24.d747ef4b.jpg";